/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const VuesaxJavascript = ({ className }) => {
  return (
    <svg
      className={`vuesax-javascript ${className}`}
      fill="none"
      height="54"
      viewBox="0 0 54 54"
      width="54"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M23.8905 16.2725V36.4775L16.8705 34.4525"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="3"
      />
      <path
        className="path"
        d="M37.1205 16.25L30.033 17.2625V28.4L37.1205 27.3875V34.475L29.0206 36.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="3"
      />
      <path
        className="path"
        d="M7.46561 11.5475L7.01558 7.4975C6.85808 6.17 7.91556 5 9.24306 5H44.7256C46.0756 5 47.1106 6.17 46.9531 7.4975L42.9031 43.9925C42.8131 44.8925 42.1605 45.6575 41.283 45.905L27.6031 49.82C27.1981 49.9325 26.7705 49.9325 26.3655 49.82L12.6856 45.905C11.8081 45.6575 11.1781 44.8925 11.0656 43.9925L8.59061 21.6725"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="3"
      />
    </svg>
  );
};
